import React, {useState} from 'react';
import Box from './Box';
import PrizeBox from './PrizeBox';
import Button from './Button';
import {Carousel, Collapse, Modal} from 'antd';
import LotteryNum from './LotteryNum';
import "./custom.css";
import axios from 'axios';
import {message, Spin} from 'antd';
import {useToken} from "../context/TokenContext";

const baseURL = process.env.REACT_APP_API_BASE_URL;


const DashBoardBodyMerchant = ({lotteryCount}) => {
    const [token, setToken] = useToken();
    const [lotteryData, setLotteryData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [sendEmailButtonClicked, setSendEmailButtonClicked] = useState(false);
    const date1 = new Date(Date.parse('2024-11-08'));
    const date2 = new Date(Date.parse('2024-11-20'));

    async function getCurrentMonthLotteries(){
        const today = new Date();
        console.log(date1);
        if (today < date1){
            message.info("Сугалааны дугаарууд 2024/11/08-д бэлэн болох тул та түр хүлээнэ үү.");
        } else if (today < date2){
            try{
                setModalOpen(true);
                const response = await axios.get(`${baseURL}/happypay/happy-merchant.php/lotteries`, {
                    headers: {
                        Authorization : token,
                    },
                    params: {
                        monthNum: 10
                    }
                });
                if (response.status === 200){
                    setLotteryData(response.data);
                }
            } catch (error){
                message.error("Серверт холбогдоход алдаа гарлаа та тзр хүлээн дахин оролдоно уу!");
                setLotteryData(null);
                setModalOpen(false);
            }
        }
        else{
            try{
                setModalOpen(true);
                const response = await axios.get(`${baseURL}/happypay/happy-merchant.php/lotteries`, {
                    headers: {
                        'Authorization' : token,
                        'Content-type' : 'application/json'
                    },

                    params:{
                        monthNum: 11,
                    }
                });
                if (response.status === 200){
                    setLotteryData(response.data);
                }
            } catch (error){
                message.error("Серверт холбогдоход алдаа гарлаа та тзр хүлээн дахин оролдоно уу!");
                setLotteryData(null);
                setModalOpen(false);
            }
        }
    }

    async function getPreviousMonthLotteries(){
        const today = new Date();
        if (today < date2){
            message.info("11-р сарын эрхийн дугаар 2024/12/20-ны өдөр харагдана. 10-р сарын эрхийн дугаарыг эрхийн дугаар харагдах товч дээр дарж авна уу.");
        } else {
            try{
                setModalOpen(true);
                const response = await axios.get(`${baseURL}/happypay/happy-merchant.php/lotteries`, {
                    headers: {
                        'Authorization' : token,
                        'Content-type' : 'application/json'
                    },
                    params: {
                        monthNum: 10,
                    }
                });
                if (response.status === 200){
                    setLotteryData(response.data);
                }
            } catch (error){
                message.error("Серверт холбогдоход алдаа гарлаа та тзр хүлээн дахин оролдоно уу!");
                setLotteryData(null);
                setModalOpen(false);
            }
        }
    }

    function handleModalClose(){
        setModalOpen(false);
        setLotteryData(null);
    }

    async function getLotteryByEmail(){
        setSendEmailButtonClicked(true);
        try{
            const response = await axios.post(`${baseURL}/happypay/happy-merchant.php/lotteries`, {
                monthNum: lotteryData.monthNum
            },{

                headers: {
                    'Authorization' : token,
                    'Content-type' : 'application/json'
                }
            });
            if(response.status === 200){
                let email = response.data.firstLetterEmail + "*****" + response.data.lastLetterEmail + "@****." + response.data.tld;
                message.info(`Таны ${email} хаягт сугалааны дугааруудыг явууллаа.`);
            }
        } catch (error){
            if(error.response){
                switch(error.response.status){

                }
            } else{
                message.error("Серверт холбогдоход алдаа гарлаа та тзр хүлээн дахин оролдоно уу!");
            }
        } finally {
            setLotteryData(null);
            setModalOpen(false);
            setSendEmailButtonClicked(false);
        }
    }

    return (<div style={{height: "calc(100% - 128px)", backgroundColor: "rgb(226 232 240)"}}
                 className='w-full flex laptop:mt-10 tablet:mt-10 mobile:mt-10 bg-slate-200'>
        {lotteryCount != null ? (
            <>
                <div
                    className='w-2/3 h-full flex flex-col justify-center items-center space-y-10 laptop:space-y-2 tablet:space-y-8 tablet:w-full mobile:space-y-8 mobile:w-full laptop:h-[600px]'>
                    <div
                        className='w-full h-[700px] flex space-x-10 laptop:space-x-2 tablet:flex-col tablet:space-x-0 tablet:space-y-8 mobile:flex-col mobile:space-x-0 mobile:space-y-8'>
                        <Box
                            style="p-10 w-1/2 h-full bg-white flex flex-col justify-center  items-center  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[330px] mobile:w-full mobile:h-[420px] mobile:px-2">
                            <p className='uppercase text-[#0987F3] font-semibold text-xl'>миний урамшууллын эрх</p>
                            <div className='flex flex-col justify-center items-center text-[#0987F3]'><p
                                className='font-bold text-7xl'>{lotteryCount}</p><p className='text-xl'>ширхэг</p></div>
                            <Button
                                onclick={getCurrentMonthLotteries}
                                style="bg-[#0168D7] text-white text-sm font-semibold rounded-md w-[200px] h-10 shadow-lg hover:opacity-90 duration-150 mt-5 mb-4"
                                name='Эрхийн дугаар харах'/>
                        </Box>
                        <Modal
                            open={(modalOpen)}
                            onCancel={handleModalClose}
                            footer={null}
                        >
                            {lotteryData != null ? (
                                <>
                                    <span className="text-xl text-[#0168D7] text-center font-semibold w-full">Таны 2024 оны {lotteryData.monthNum} сард цуглуулсан сугалааны дугаарууд</span>
                                    <div className="flex flex-col items-center gap-5">
                                        <div className="w-full grid grid-cols-4 gap-4 overflow-y-auto h-1/3 pr-1 my-custom-scrollbar my-6 mobile-Merchant:h-60 tablet-Merchant:h-1/3 tablet-Merchant:grid-cols-3 mobile:grid-cols-1">
                                            {lotteryData.lotteries.map((lottery, index) => (
                                                <LotteryNum num={lottery} key={index}/>
                                            ))}
                                        </div>
                                        <div className="flex gap-2 h-10">
                                            {sendEmailButtonClicked ? (
                                                <Spin/>
                                            ) : (
                                                parseInt(lotteryCount) > 0 && (
                                                    <Button
                                                        style="bg-[#0168D7] text-white rounded-md h-10 w-[180px]"
                                                        onClick={getLotteryByEmail}
                                                        name="Имейлээр авах"
                                                    />
                                                )
                                            )}
                                        </div>


                                    </div>
                                </>
                            ) : <Spin className='block m-auto'/>}

                        </Modal>
                        <Box
                            style="p-8 w-1/2 bg-white flex flex-col justify-center gap-10  laptop:p-4 laptop:py-6 tablet:w-full tablet:h-[480px] tablet:px-24 mobile:w-full mobile:h-[500px] mobile:px-2">
                            <p className='uppercase text-[#0987F3] font-semibold text-xl'>урамшууллын хонжворууд</p>
                            <div className='flex flex-col justify-center items-center text-[#0168D7] gap-3'>
                                <PrizeBox prize={"100,000₮"} txt={"Эрхийн бичиг"}
                                          style="w-full p-8 laptop:w-[300px] h-[50px] tablet:min-w-[400px] tablet:max-w-[700px] flex justify-around gap-2 items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:min-w-[300px] mobile:max-w-[600px]"
                                          type={true}/>
                                <PrizeBox prize={"500,000₮"} txt={"Эрхийн бичиг"}
                                          style="w-full p-8 laptop:w-[300px] h-[50px] tablet:min-w-[400px] tablet:max-w-[700px]  flex justify-around gap-2 items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:min-w-[300px] mobile:max-w-[600px]"
                                          type={true}/>
                                <PrizeBox prize={"1,000,000₮"} txt={"Эрхийн бичиг"}
                                          style=" w-full p-8 laptop:w-[300px] h-[50px] tablet:min-w-[400px] tablet:max-w-[700px]  flex justify-around items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3] text-md mobile:min-w-[300px] mobile:max-w-[600px]"
                                          type={true}/>
                                <PrizeBox prize={"Супер урамшуулал"} txt={"Гадаадад аялах эрх"}
                                          style="p-8 w-full laptop:w-[300px] h-[50px] tablet:min-w-[400px] tablet:max-w-[700px]  flex justify-around gap-2 items-center rounded-lg border-2 border-[#FBB403] text-[#0987F3]  mobile:min-w-[300px] mobile:max-w-[600px]"
                                          type={true}/>
                            </div>

                            <Button
                                onclick={getPreviousMonthLotteries}
                                style="bg-[#0168D7] text-white text-sm text-center block mx-auto p-5 font-semibold rounded-md w-[250px] h-10 shadow-lg hover:opacity-90 duration-150 "
                                name='Өмнөх сарын эрхийн дугаар'/>
                        </Box>
                        <br/>
                    </div>

                </div>
                <div className='w-1/3 pl-10 h-[700px] laptop:pl-2 tablet:hidden mobile:hidden laptop:h-[600px]'>
                    <Box style="w-full h-full bg-white"><img className='object-cover w-full h-full rounded-lg'
                                                             src="/images/happy_merchant_2025-mobile.jpg"/></Box>
                </div>
            </>
        ) : <Spin className="block mx-auto my-[50%]" />}

    </div>);
}

export default DashBoardBodyMerchant;